import { render, staticRenderFns } from "./ExamMarkIndex.vue?vue&type=template&id=4abb9beb"
import script from "./ExamMarkIndex.vue?vue&type=script&lang=js"
export * from "./ExamMarkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports